import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import { Message ,MessageBox} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/styles/variables.css'
import '@/assets/styles/base.css'
import '@/assets/styles/layout.css'
import '@/assets/styles/components.css'
import '@/assets/styles/utilities.css'
import '@/assets/styles/pagination.css'
import '@/assets/styles/tables.css'
import store from './store';


// 全局注册（可在任意组件中使用）
Vue.use(ElementUI);
Vue.prototype.$message = Message // 显式挂载


// 自定义全局 $modal 对象
Vue.prototype.$modal = {
  msgSuccess(msg) {
    Message.success(msg) // 调用ElementUI的$message.success
  },
  // 可以继续扩展其他方法，如错误提示、确认框等
  msgError(msg) {
    Message.error(msg)
  },
  confirm(text, title = '提示') {
    return MessageBox.confirm(text, title, { type: 'warning' })
  }
}


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
